import PendingPayouts from './PendingPayouts';

export default PendingPayouts;
